import React from "react";
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { SvgIcon } from '@mui/material';
import { PermIdentity as PermIdentityIcon } from '@mui/icons-material';
import Age from '../../Helpers/Dates/Age';
import States from '../../Helpers/Lists/States';
import ConvertToShortHandHeight from '../../Helpers/Formatters/ShortHandHeight';
import TobaccoUsage from "./Helpers/TobaccoUsage";
import PinLocationIcon from '../../../icons/pin-location.svg?react';
import NoSmokeIcon from '../../../icons/no-smoke.svg?react';
import HeightIcon from '../../../icons/height.svg?react';
import "./QuoteBasicInfo.scss";

export default function QuoteBasicInfo(props) {
    
    return (
        <div className="quote bg-white">
            <Row className="text-center">
                <Col className="line d-flex flex-column align-items-center">
                <div className={`icon-container background-color-16`}>
                    <SvgIcon component={PinLocationIcon} color='primary' />
                </div>
                <p className="card-title">Getting Options for</p>
                <div className='mt-1'>
                    { States().map(s => s.value === props.basicInfo.state ? s.label : "") }
                    </div>
                </Col>
                <Col className="line d-flex flex-column align-items-center">
                <div className={`icon-container background-color-16`}>
                    <SvgIcon component={PermIdentityIcon} color='primary' />
                </div>
                <p className="card-title">Calculating rates for</p>
                <div className='mt-1'>
                    {props.basicInfo.gender === 'F' ? 'Female' : 'Male'}</div>
                <div className="mt-1">{Age(props.basicInfo.birthdate)} Years Old</div>
                </Col>
                <Col className="line d-flex flex-column align-items-center">
                <div className={`icon-container background-color-16`}>
                    <SvgIcon component={HeightIcon} color='primary' />
                </div>
                <p className="card-title">Height &amp; Weight</p>
                <div className='mt-1'> {props.basicInfo.height !== null ? ConvertToShortHandHeight(props.basicInfo.height) : ""}</div>
                <div className="mt-1"> {props.basicInfo.weight !== null ? props.basicInfo.weight.replace(" pounds","lbs") : ""}</div>
                </Col>
                <Col className="d-flex flex-column align-items-center">
                <div className={`icon-container background-color-16`}>
                    <SvgIcon component={NoSmokeIcon} color='primary' />
                </div>
                <p className="card-title">Tobacco Modifier</p>
                <div className='mt-1'>{TobaccoUsage(props.basicInfo.tobacco) === 'true' ? 'Consumed Tobacco' : 'No Tobacco'}</div>
                </Col>
            </Row>
        </div>
    )
}

QuoteBasicInfo.propTypes = {
    basicInfo: PropTypes.object.isRequired,
};
